import { render } from "./OvRemoveModal.vue?vue&type=template&id=56f19b22&scoped=true"
import script from "./OvRemoveModal.vue?vue&type=script&lang=js"
export * from "./OvRemoveModal.vue?vue&type=script&lang=js"

import "./OvRemoveModal.vue?vue&type=style&index=0&id=56f19b22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f19b22"],['__file',"src/components/OvRemoveModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56f19b22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56f19b22', __exports__)) {
    api.reload('56f19b22', __exports__)
  }
  
  module.hot.accept("./OvRemoveModal.vue?vue&type=template&id=56f19b22&scoped=true", () => {
    api.rerender('56f19b22', render)
  })

}


export default __exports__